import { render, staticRenderFns } from "./order-notification-text.vue?vue&type=template&id=f8c3bc4c&"
import script from "./order-notification-text.vue?vue&type=script&lang=js&"
export * from "./order-notification-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports